interface Hero {
  backgroundImage: HTMLImageElement | null;
}

export const heros = Array.from(document.querySelectorAll(".js-hero")).map(
  (hero): Hero => {
    return {
      backgroundImage: hero.querySelector(".js-hero-background-image"),
    };
  }
);

export const heroBackgroundImageParallaxTick = (hero: Hero): boolean => {
  window.requestAnimationFrame(() => heroBackgroundImageParallaxTick(hero));

  if (!hero.backgroundImage) {
    return false;
  }

  hero.backgroundImage.style.setProperty(
    "--transform-translate-y",
    `${window.pageYOffset * 0.1}px`
  );

  return true;
};

heros.map((hero) => {
  if (hero.backgroundImage) {
    heroBackgroundImageParallaxTick(hero);
  }
});
